module.exports = __webpack_public_path__ + "static/media/timer.593d700f.svg";